/* Purchase presentation follows the original form, price and native add handler. */
(function () {
  'use strict';
  if (window.MTProductPurchase) return;
  const mounted = new WeakSet();
  // Reveal the existing product-specific measurements; no new size claims.
  function revealFit() {
    const panel = document.getElementById('watch-size-fit');
    if (!panel) return false;
    panel.open = true;
    panel.querySelector('summary')?.focus({ preventScroll:true });
    panel.scrollIntoView({ block:'start', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    return true;
  }
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element) || event.defaultPrevented || event.button !== 0) return;
    const link = event.target.closest('[data-mt-size-link]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (revealFit()) event.preventDefault();
  });
  function revealHashFit() {
    if (location.hash === '#watch-size-fit') {
      const panel = document.getElementById('watch-size-fit');
      if (panel) panel.open = true;
    }
  }
  addEventListener('hashchange', revealHashFit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealHashFit, { once:true });
  else revealHashFit();
  const cookieSelector = '#shopify-pc__banner, #shopify-pc__prefs, .cookies-bar, [data-mt-sticky-obstruction]';
  const chatSelector = 'shopify-chat, #ShopifyChat, .shopify-chat, [data-shopify-chat], #gorgias-chat-container, #tidio-chat-iframe, #intercom-container, .crisp-client, iframe[title="chat" i], iframe[title*="chat widget" i]';
  const obstructionSelector = cookieSelector + ', ' + chatSelector;

  function textOnly(markup) {
    const node = document.createElement('span');
    node.innerHTML = markup;
    return node.textContent.replace(/\s+/g, ' ').trim();
  }

  function visibleBox(node) {
    const box = node.getBoundingClientRect();
    const style = getComputedStyle(node);
    if (!box.width || !box.height || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0 || node.hidden) return null;
    return box;
  }

  function mount(scope) {
    scope.querySelectorAll('[data-mt-purchasebar]').forEach(function (bar) {
      if (mounted.has(bar)) return;
      const form = document.getElementById(bar.dataset.formId);
      const primary = form && form.querySelector('[data-mt-primary-add]');
      const summary = form && form.closest('.product-summary');
      if (!primary || !summary) return;
      mounted.add(bar);
      const trigger = bar.querySelector('[data-mt-purchase-trigger]');
      const price = summary.querySelector('.mt-price-row .product-price');
      const barPrice = bar.querySelector('[data-mt-bar-price]');
      const savings = summary.querySelector('[data-mt-save-badge]');
      const gift = summary.querySelector('[data-mt-product-gift]');
      const addLabel = primary.dataset.mtAddLabel || 'Add to bag';
      const unavailableLabel = primary.dataset.mtUnavailableLabel || 'Unavailable';
      const currencyCode = primary.dataset.mtCurrency || '';
      let queued = false;
      let maximumViewportHeight = innerHeight;

      function compactMoney(value) {
        let label = textOnly(value);
        if (currencyCode && label.endsWith(' ' + currencyCode)) label = label.slice(0, -(currencyCode.length + 1)).trim();
        return label;
      }

      function formatMoney(amount) {
        const value = Number(amount);
        if (!Number.isFinite(value) || value < 0) return '';
        try {
          if (typeof window.btyFormatPrice === 'function') return compactMoney(window.btyFormatPrice(value, primary.dataset.mtMoneyFormat));
        } catch (_) { /* A missing native format must never substitute the product price. */ }
        if (!currencyCode) return '';
        try {
          return compactMoney(new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style:'currency', currency:currencyCode }).format(value / 100));
        } catch (_) { return ''; }
      }

      function displayedMoney() {
        if (!price) return primary.dataset.mtPrice || '';
        let current;
        if (price.querySelector('.price__container')) {
          current = price.classList.contains('price--on-sale') ? price.querySelector('.price__sale .price-item--sale') : price.querySelector('.price__regular .price-item');
        } else current = price.querySelector('span.price') || price.querySelector('span.regular-price');
        if (!current) return primary.dataset.mtPrice || '';
        const clone = current.cloneNode(true);
        clone.querySelectorAll('.sr-only, .visually-hidden').forEach(node => node.remove());
        return compactMoney(clone.textContent) || primary.dataset.mtPrice || '';
      }

      function isUnavailable() {
        return primary.disabled || primary.classList.contains('disabled') || form.classList.contains('disabled');
      }

      function isBusy() {
        return primary.classList.contains('loading') || primary.dataset.mtAdding === 'true' || primary.getAttribute('aria-busy') === 'true';
      }

      function paintPrimary(unavailable, busy, amount) {
        const label = busy ? 'Adding…' : unavailable ? unavailableLabel : addLabel;
        const showPrice = !unavailable && !busy && amount;
        const expected = label + (showPrice ? ' · ' + amount : '');
        if (primary.textContent.replace(/\s+/g, ' ').trim() === expected) return;
        const labelNode = document.createElement('span');
        labelNode.dataset.mtCtaLabel = '';
        labelNode.textContent = label;
        const children = [labelNode];
        if (showPrice) {
          const separator = document.createElement('span');
          separator.setAttribute('aria-hidden', 'true');
          separator.textContent = ' · ';
          const amountNode = document.createElement('span');
          amountNode.dataset.mtCtaPrice = '';
          amountNode.textContent = amount;
          children.push(separator, amountNode);
        }
        // Only presentation children change. Native loading/disabled/lock stay intact.
        primary.replaceChildren(...children);
      }

      function obstruction(viewportBottom) {
        let blocked = false, left = 0, right = 0;
        document.querySelectorAll(cookieSelector).forEach(node => {
          const box = visibleBox(node);
          if (box && box.top < viewportBottom && box.bottom > 0) blocked = true;
        });
        document.querySelectorAll(chatSelector).forEach(node => {
          const box = visibleBox(node);
          if (!box || box.top >= viewportBottom || box.bottom < viewportBottom - 180) return;
          if (box.width > 180 || box.height > 180) { blocked = true; return; }
          if (box.right > innerWidth / 2) right = Math.max(right, Math.min(112, innerWidth - box.left + 10));
          else left = Math.max(left, Math.min(112, box.right + 10));
        });
        return { blocked:blocked || left + right > innerWidth / 3, left, right };
      }

      function sync() {
        queued = false;
        if (!bar.isConnected) return;
        const viewport = window.visualViewport;
        const viewportHeight = viewport ? viewport.height : innerHeight;
        const viewportBottom = viewportHeight + (viewport ? viewport.offsetTop : 0);
        const activeField = document.activeElement;
        const editing = activeField && (activeField.matches('input, textarea, select') || activeField.isContentEditable);
        const keyboardOpen = editing && (maximumViewportHeight - viewportHeight > 140 || innerHeight - viewportHeight > 100);
        const header = document.querySelector('.header');
        const headerBottom = header ? Math.max(0, Math.min(160, header.getBoundingClientRect().bottom)) : 0;
        const primaryBox = primary.getBoundingClientRect();
        const passed = primaryBox.height > 0 && primaryBox.bottom <= headerBottom;
        const footer = document.querySelector('.footer');
        const beforeFooter = !footer || footer.getBoundingClientRect().top > viewportBottom;
        const overlay = document.documentElement.classList.contains('side-cart-open') || document.documentElement.classList.contains('quick-view-open') || document.querySelector('.pswp--open');
        const space = obstruction(viewportBottom);
        bar.hidden = !(passed && beforeFooter && !keyboardOpen && !space.blocked && !overlay);
        bar.style.setProperty('--mt-chat-left', space.left + 'px');
        bar.style.setProperty('--mt-chat-right', space.right + 'px');
        const reserve = bar.hidden ? '0px' : Math.ceil(bar.getBoundingClientRect().height) + 'px';
        if (document.body.style.getPropertyValue('--mt-purchasebar-space') !== reserve) document.body.style.setProperty('--mt-purchasebar-space', reserve);
        summary.style.setProperty('--mt-pdp-sticky-top', headerBottom + 20 + 'px');
        summary.classList.toggle('mt-summary-can-stick', innerWidth >= 992 && summary.getBoundingClientRect().height < viewportHeight - headerBottom - 40);
        const unavailable = isUnavailable(), busy = isBusy(), amount = displayedMoney();
        paintPrimary(unavailable, busy, amount);
        trigger.disabled = unavailable || busy;
        const label = busy ? 'Adding…' : unavailable ? unavailableLabel : addLabel;
        if (trigger.textContent !== label) trigger.textContent = label;
        if (price && barPrice.innerHTML !== price.outerHTML) barPrice.innerHTML = price.outerHTML;
      }

      function schedule() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
      trigger.addEventListener('click', function () {
        sync();
        if (trigger.disabled) return;
        primary.click();
        sync();
      });
      document.addEventListener('product-variant-updated', function (event) {
        const selected = event.detail && event.detail.selected;
        const variantInput = form.querySelector('[name="id"]');
        if (selected && variantInput && String(selected.id) !== String(variantInput.value)) return;
        const unavailable = !selected || !selected.available;
        if (primary.disabled !== unavailable) primary.disabled = unavailable;
        primary.setAttribute('aria-disabled', String(unavailable));
        if (selected) {
          const formattedPrice = formatMoney(selected.price);
          if (formattedPrice) primary.dataset.mtPrice = formattedPrice;
        }
        if (gift) gift.hidden = unavailable || !selected || selected.price <= 0;
        if (savings) {
          const saving = selected && selected.compare_at_price > selected.price ? selected.compare_at_price - selected.price : 0;
          const formattedSaving = saving > 0 ? formatMoney(saving) : '';
          savings.hidden = !formattedSaving;
          if (formattedSaving) savings.textContent = 'Save ' + formattedSaving;
        }
        schedule();
      });
      new MutationObserver(schedule).observe(primary, { attributes:true, attributeFilter:['disabled','class','aria-busy','data-mt-adding'], childList:true, subtree:true });
      if (price) new MutationObserver(schedule).observe(price, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
      if (window.ResizeObserver) new ResizeObserver(schedule).observe(summary);
      new MutationObserver(schedule).observe(document.documentElement, { attributes:true, attributeFilter:['class'] });
      new MutationObserver(function (records) {
        if (records.some(record => record.target instanceof Element && record.target.closest(obstructionSelector) || [...record.addedNodes, ...record.removedNodes].some(node => node instanceof Element && (node.matches(obstructionSelector) || node.querySelector(obstructionSelector))))) schedule();
      }).observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['hidden','style','class','open'] });
      addEventListener('scroll', schedule, { passive:true });
      addEventListener('resize', function () { maximumViewportHeight = Math.max(maximumViewportHeight, innerHeight); schedule(); });
      addEventListener('focusin', schedule);
      addEventListener('focusout', schedule);
      window.visualViewport?.addEventListener('resize', schedule);
      window.visualViewport?.addEventListener('scroll', schedule);
      sync();
    });
  }
  window.MTProductPurchase = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once:true });
  else mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
}());
